import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

// components
import BallPulseLoader from "../BallPulseLoader/BallPulseLoader";

//styles
import "./SlidingTextButton.scoped.scss";

const SlidingTextButton = props => {
	let { text, icon, background = "blue", slim = false, disabled, border, onClick = () => { }, ...otherProps } = props;
	const [noSliding, setNoSliding] = useState(false);
	const [loading, setLoading] = useState(false);
	const buttonRef = useRef();

	if (disabled || loading) onClick = () => { };

	function handleClick(e) {
		const result = onClick(e);
		if (!(result instanceof Promise)) return;
		setLoading(true);
		result.finally(() => setLoading(false));
	}

	useEffect(() => {
		const el = buttonRef.current;
		if (!el) return;

		const observer = new ResizeObserver(([myButton]) => {
			const textContainerSize = myButton.target.querySelector(".sliding_text_container").offsetWidth;
			const textSize = myButton.target.querySelector(".text").offsetWidth;
			if (noSliding && textContainerSize === textSize) return;
			setNoSliding(textSize <= textContainerSize);
		});

		observer.observe(el);
		return () => observer.unobserve(el);
	}, [noSliding]);

	const classList = ["sliding_button", background];
	loading && classList.push("button_loading");
	noSliding && classList.push("no_sliding");
	disabled && classList.push("disabled");
	slim && classList.push("slim");
	!disabled && border && classList.push("border");

	return (
		<div className={classList.join(" ")} ref={buttonRef} onClick={handleClick} {...otherProps}>
			{!loading ? icon : ""}
			<div className="sliding_text_container">
				<div className="text">{loading ? <BallPulseLoader style={{ height: "19px" }} /> : text}</div>
			</div>
		</div>
	);
};

SlidingTextButton.propTypes = {
	text: PropTypes.string.isRequired,
	icon: PropTypes.element,
	background: PropTypes.oneOf(["blue", "darkBlue", "green", "darkGreen", "red", "purple", "orange", "pink"]),
	slim: PropTypes.bool,
	disabled: PropTypes.bool,
	border: PropTypes.bool,
	onClick: PropTypes.func
};

export default SlidingTextButton;
